<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../../store/calculator.js';

const calculator = useCalculatorStore();
const { periods, selectedPeriod } = storeToRefs(calculator);

const selectedPeriodName = computed(() => periods.value.find(p => p.id === selectedPeriod.value)?.name);
</script>

<template>
  <p class="cloud-calculator__summary-row" v-if="selectedPeriodName">
    <span class="cloud-calculator__summary-label">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_LABEL_PERIOD') }}:
    </span>
    <span class="cloud-calculator__summary-value">
      {{ selectedPeriodName }}
    </span>
  </p>
</template>
